<form [formGroup]="group">
    <bt-file-picker-form
        [formControlName]="model.id"
        [model]="model"
        [value]="model.value"
        [required]="model.required"
        (blur)="onBlur($event)"
        (change)="onChange($event)"
        (focus)="onFocus($event)">
    </bt-file-picker-form>
</form>